import { useEffect } from "react";
import { Widget } from "@typeform/embed-react";
import { useUser } from "@src/hooks";
import CloseIcon from "@src/assets/icons/close.svg?react";
import styles from "./ScheduleSupportCallModal.module.scss";

const BODY_CLASS_WHEN_OPEN = "scheduleSupportModalOpen";

type Props = {
  open: boolean;
  onClose: () => void;
  lessonName?: string;
  country?: string;
};

const SUPPORT_CALL_TYPEFORM_ID = "nftVJf4A";
const CLOSE_DELAY_AFTER_SUBMIT_MS = 1500;

function ScheduleSupportCallModal({
  open,
  onClose,
  lessonName = "",
  country = "",
}: Props) {
  const [user] = useUser();

  useEffect(() => {
    if (open) {
      document.body.classList.add(BODY_CLASS_WHEN_OPEN);
    }
    return () => {
      document.body.classList.remove(BODY_CLASS_WHEN_OPEN);
    };
  }, [open]);

  const hidden = {
    account: user?.customer?.name ?? "",
    school: user?.schools?.[0]?.name ?? "",
    course: "standalone",
    unit: "",
    country,
    lesson: lessonName,
    email: user?.email ?? "",
  };

  const handleSubmit = () => {
    setTimeout(onClose, CLOSE_DELAY_AFTER_SUBMIT_MS);
  };

  if (!open) return null;
  return (
    <div className={styles.wrapper}>
      <div className={styles.backdrop} onClick={onClose} />
      <button
        type="button"
        onClick={onClose}
        className={styles.closeWrapper}
        aria-label="Close"
      >
        <CloseIcon className={styles.closeIcon} />
      </button>
      <div className={styles.typeFormContainer}>
        <Widget
          id={SUPPORT_CALL_TYPEFORM_ID}
          hidden={hidden}
          onSubmit={handleSubmit}
          redirectTarget="_blank"
        />
      </div>
    </div>
  );
}

export default ScheduleSupportCallModal;
